<h2>With your own model.</h2>
<p class="order-card__price"><strong>${{ price }}</strong><span>One-time</span></p>
<ul class="check-list order-card__benefits">
  <li *ngFor="let benefit of benefits">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 8.94753L5.2 13.1475L15 3.34753" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    {{ benefit }}
  </li>
</ul>
<button class="rf-button order-card__cta" type="button" (click)="onUpload()">Upload your model</button>
<button *ngIf="offerVideos" class="rf-text-link order-card__back" type="button" (click)="onVideos()">See the sample's finished videos</button>
